export const brands = [
  {
    path: "/brands",
    name: "brands",
    label: "Brands",
    icon: "bookmark",
    component: () => import("@/views/Brands/BrandsList.vue"),
    meta: {
      title: "Brands",
      ability: { action: "read", subject: "Brand" },
    },
  },
  {
    path: "/brands/:id",
    name: "brands.index",
    component: () => import("@/views/Brands/BrandsDetails.vue"),
    meta: {
      title: "Brands Details",
      ability: { action: "Update", subject: "Brand" },
    },
  },
];
